"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random = exports.search = void 0;
var axios = require('axios');
var APIKey = '7mHafSd3ILuo78L6ARh9u0i2wRhNVU23';
var instance = axios.create({
    baseURL: 'https://api.giphy.com/v1/gifs/',
    timeout: 1000,
    method: 'GET',
});
var search = function (query, limit, offset, lang, bundle) {
    if (limit === void 0) { limit = 25; }
    if (offset === void 0) { offset = 0; }
    if (lang === void 0) { lang = 'en'; }
    if (bundle === void 0) { bundle = 'messaging_non_clips'; }
    return instance.get("/search?api_key=".concat(APIKey, "&q=").concat(query, "&limit=").concat(limit, "&offset=").concat(offset, "&rating=g&lang=").concat(lang, "&bundle=").concat(bundle));
};
exports.search = search;
var random = function () {
    return instance.get("random?api_key=".concat(APIKey, "&tag=&rating=g"));
};
exports.random = random;
